import { useAppSettingsStore } from '@/stores/appSettings';
import { useSignedUrlEpochStore } from '@/stores/signedUrlEpoch';

export async function handleAppResume() {
  await useAppSettingsStore().refreshFromApi();
  useSignedUrlEpochStore().bumpSignedUrlEpoch();
}
